import { IconButton } from '@mui/material';
import { IconTrash } from '@tabler/icons-react';
import { TransactionLimit } from './data/useGetLimitsBySegment';
/**
 * Limits management table columns
 * @param onDeleteClick  Callback when delete icon is clicked
 * @returns
 */
export const columns = (onDeleteClick: (v: TransactionLimit) => void) => [
  {
    title: 'LIMITS:COLUMNS:TRANSACTION_TYPE',
    content: (trx: TransactionLimit) => {
      return trx?.transactionType;
    },
  },
  {
    title: 'LIMITS:COLUMNS:DESCRIPTION',
    content: (trx: TransactionLimit) => {
      return trx?.description;
    },
  },
  {
    title: '',
    content: (trx: TransactionLimit) => {
      return (
        <IconButton
          onClick={(e) => {
            e.stopPropagation();
            onDeleteClick(trx);
          }}
        >
          <IconTrash />
        </IconButton>
      );
    },
  },
];
